module.exports = __webpack_public_path__ + "images/sns_campaign_lp/mainvisual-date-pc@2x_95155595212e17f6018d35c9263129e2.png";